import { CustomBarChart } from '@/features/charts/components/chart-types/bar-chart-components/custom-bar-chart';
import { CustomBatteryChart } from '@/features/charts/components/chart-types/battery-chart-components/custom-battery-chart';
import { CustomLineChart } from '@/features/charts/components/chart-types/line-chart-components/custom-line-chart';
import { CustomPieChart } from '@/features/charts/components/chart-types/pie-chart-components/custom-pie-chart';
import {
  ChartType,
  AggregationType,
} from '@/features/charts/components/create-chart-type-selection';
import { ChartResult, ChartSettings } from '@/features/charts/util/chart-util';
import { KpiType } from '@/shared/types/api';
import { KpiUnit } from '@/shared/types/kpi';

export const BaseChart = ({
  chartType,
  chartResult,
  chartSettings,
  colors,
  aggregationType,
  maxValue,
  chartClassName,
  unit,
}: {
  chartType: ChartType;
  chartResult: ChartResult;
  chartSettings?: ChartSettings;
  colors: string[];
  aggregationType: AggregationType;
  kpiType: KpiType;
  maxValue?: number;
  chartClassName?: string;
  unit: string | KpiUnit | null;
}) => {
  return (
    <div>
      {(() => {
        switch (chartType) {
          case ChartType.BAR:
            return (
              <CustomBarChart
                chartResult={chartResult}
                chartSettings={chartSettings}
                colors={colors}
                aggregationType={aggregationType}
                className={chartClassName}
                maxValue={maxValue}
                unit={unit}
              />
            );
          case ChartType.LINE:
            return (
              <CustomLineChart
                chartResult={chartResult}
                colors={colors}
                className={chartClassName}
                maxValue={maxValue}
                unit={unit}
              />
            );
          case ChartType.PIE:
            return (
              <CustomPieChart
                chartResult={chartResult}
                maxValue={maxValue}
                className={chartClassName}
                aggregationType={aggregationType}
              />
            );
          case ChartType.BATTERY:
            return (
              <CustomBatteryChart
                chartResult={chartResult}
                chartSettings={chartSettings}
                maxValue={maxValue ?? 100}
                className={chartClassName}
              />
            );
          default:
            return <div>Chart type {chartType} not implemented yet</div>;
        }
      })()}
    </div>
  );
};
